import CSVPreviewSection from '../CSVPreviewSection'
import BillingSummaryCSVPreviewUtils from './BillingSummaryCSVPreviewUtils'

export default function BillingSummaryCSVPreviewGroupingSection(){}
BillingSummaryCSVPreviewGroupingSection.prototype = new CSVPreviewSection();
BillingSummaryCSVPreviewGroupingSection.prototype.init = function(
    firstGroupingLevel,
    secondGroupingLevel,
    thirdGroupingLevel,
    columnsStrategy,
    numOfGroupingColumns,
    numOfGroupingRows,
    reportAuthorizationInfo,
){
    CSVPreviewSection.prototype.init.call( this );
    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    this.thirdGroupingLevel = thirdGroupingLevel;
    this.columnsStrategy = columnsStrategy;
    this.numOfGroupingColumns = numOfGroupingColumns;
    this.numOfGroupingRows = numOfGroupingRows;
    this.reportAuthorizationInfo = reportAuthorizationInfo
    return this;
};

BillingSummaryCSVPreviewGroupingSection.prototype.addRows = function ( tBody )
{
    const emptyRow = this.createRow();

    const totalsRow = this.createRow();
    this.addCell( totalsRow, this.message("report.total") );

    for( let i = 0; i < this.numOfGroupingRows; i++ ) {
        const row = this.createRow();
        const needOthers = !this.reportAuthorizationInfo.allUsersAvailable && i === this.numOfGroupingRows - 1
        BillingSummaryCSVPreviewUtils.addGroupingLevelsCells(
            row,
            this.firstGroupingLevel,
            this.secondGroupingLevel,
            this.thirdGroupingLevel,
            i === 0,
            needOthers,
        )

        this.columnsStrategy.addDataCells( row );
        this.addRow( tBody, row );
    }

    for(let i = 0; i < this.numOfGroupingColumns - 1; i++ ){
        ReportPreviewUtils.addEmptyCell( emptyRow );
        ReportPreviewUtils.addEmptyCell( totalsRow );
    }

    this.columnsStrategy.addEmptyCells( emptyRow );
    ReportPreviewUtils.addEmptyCell( emptyRow );
    this.columnsStrategy.addDataCells( totalsRow );
    this.addRow( tBody, emptyRow );
    this.addRow( tBody, totalsRow );
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/billingsummary/BillingSummaryCSVPreviewGroupingSection.js